import { render, staticRenderFns } from "./store.vue?vue&type=template&id=1bb70e81&scoped=true&"
import script from "./store.vue?vue&type=script&lang=js&"
export * from "./store.vue?vue&type=script&lang=js&"
import style0 from "./store.vue?vue&type=style&index=0&id=1bb70e81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb70e81",
  null
  
)

export default component.exports